<template>
  <div class="qrcode Kanit">
    <v-toolbar dark class="toolbarqrcode"  style="margin-top: 10px;">
      <img :src="BASE_URL + 'static/icon/user.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>สร้าง Account สำหรับ บริษัทบำรุงรักษาเครื่องAED</v-toolbar-title>
    </v-toolbar>
    <div class="horizontal-center widthdivstep">
       <v-stepper v-model="StepCreate">
      <v-stepper-header style="height: 60px;">
        <v-stepper-step step="1">ข้อมูลบริษัท</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">รายละเอียด</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">สำเร็จ</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
      <!-- step 1 -->
      <v-stepper-content step="1">
        <v-card color="grey lighten-2" class="pd-10" style="min-height:150px;">
          <p style="text-align: left; margin-bottom: 0; ">บริษัทเจ้าของ Account <span style="color: red !important;">*</span></p>
          <v-select
                :items="itemsCompany"
                item-text="company_name"
                item-value="company_id"
                v-model="CompanyOwner"
                label="เลือกบริษัทเจ้าของ Account"
                outlined
                hide-details
                single-line
                style="margin-bottom: 10px;"
              ></v-select>
            
        </v-card>
        <v-btn rounded color="primary" style="color: white; margin-bottom: 10px;margin-top: 20px;" @click="StepCreate = 2" :disabled="CompanyOwner == '' || role == ''">ถัดไป</v-btn>
      </v-stepper-content>

      <!-- step 2 -->
      <v-stepper-content step="2">
        <v-card color="grey lighten-2" class="pd-10" style="height:340px; margin-bottom: 20px; overflow: scroll;">
          <v-radio-group v-model="radioTypeInfo" style="margin-top: 2px;">
            <v-radio :key="1" :value="1" label="กำหนดเอง (1 บัญชี)" color="#aa0800ff"></v-radio>
            <div v-if="radioTypeInfo == 1" style="padding-left: 20px; padding-right: 20px;">
              <v-text-field
            label="ชื่อ"
            single-line
            outlined
            hide-details
            v-model="first_name"
            class="textfieldInput"
            style="margin-bottom: 5px;"
          >
            <template v-slot:append v-if="first_name != ''">
              <v-fade-transition leave-absolute>
                <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
              </v-fade-transition>
            </template>
          </v-text-field>
          <v-text-field
            label="นามสกุล"
            single-line
            outlined
            hide-details
            v-model="last_name"
            class="textfieldInput"
            style="margin-bottom: 5px;"
          >
            <template v-slot:append v-if="last_name != ''">
              <v-fade-transition leave-absolute>
                <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
              </v-fade-transition>
            </template>
          </v-text-field>
          <v-text-field
            label="อีเมล"
            single-line
            outlined
            hide-details
            v-model="email"
            class="textfieldInput"
            style="margin-bottom: 5px;"
            rules="emailRules"
          >
            <template v-slot:append v-if="checkEmail()">
              <v-fade-transition leave-absolute>
                <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
              </v-fade-transition>
            </template>
            <template v-slot:append v-else-if="email != ''">
              <v-fade-transition leave-absolute>
                <v-icon style="color: #dc0303; font-size: 20px;">fas fa-times-circle</v-icon>
              </v-fade-transition>
            </template>
          </v-text-field>
          <v-text-field
            label="หมายเลขโทรศัพท์"
            single-line
            outlined
            hide-details
            v-model="phone"
            mask="###-###-####"
            required
            class="textfieldInput"
            style="margin-bottom: 5px;"
            :rules="phoneRules"
          >
            <template v-slot:append v-if="checkPhone()">
              <v-fade-transition leave-absolute>
                <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
              </v-fade-transition>
            </template>
            <template v-slot:append v-else-if="phone != ''">
              <v-fade-transition leave-absolute>
                <v-icon style="color: #dc0303; font-size: 20px;">fas fa-times-circle</v-icon>
              </v-fade-transition>
            </template>
          </v-text-field>
          <v-text-field
            label="ชื่อผู้ใช้งาน"
            single-line
            outlined
            v-model="username"
            class="textfieldInput"
            style="margin-bottom: 5px;"
            :hide-details="checkusername()"
            :rules="usernameRules"
          ></v-text-field>
          <v-text-field
            label="รหัสผ่าน"
            single-line
            outlined
            hide-details
            v-model="password"
            type="password"
            class="textfieldInput"
            style="margin-bottom: 5px;"
            :hide-details="checkpassword()"
            :rules="passwordRules"
          ></v-text-field>
          <v-text-field
            label="ยืนยันรหัสผ่าน"
            single-line
            outlined
            :hide-details="checkrepassword()"
            :rules="repasswordRules"
            v-model="repassword"
            class="textfieldInput"
            type="password"
            style="margin-bottom: 5px;"
          ></v-text-field>

            </div>
            <v-radio :key="2" :value="2" label="ระบบสร้างให้ (หลายบัญชี)" color="#aa0800ff"></v-radio>
            <div v-if="radioTypeInfo == 2" style="padding-left: 20px; padding-right: 20px;">
               <v-text-field
            label="จำนวนบัญชีที่ต้องการสร้าง"
            single-line
            outlined
            hide-details
            v-model="NumAccount"
            type=number
            min=1
            style="margin-bottom: 10px;"
          ></v-text-field>



            </div>
          </v-radio-group>
        </v-card>
        <v-btn rounded text style="margin-bottom: 10px;" @click="StepCreate = 1">ย้อนกลับ</v-btn>
        <v-btn rounded color="primary" style="color: white; margin-bottom: 10px;" @click="CreateAccount()" v-if="radioTypeInfo== 2">ถัดไป</v-btn>
        <v-btn rounded color="primary" style="color: white; margin-bottom: 10px;" @click="CreateAccount()" :disabled="checkNext()" v-else>ถัดไป</v-btn>
      </v-stepper-content>

       <v-stepper-content step="3">
        <v-card color="grey lighten-2" class="mb-12 pd-10" height="200px" style="overflow: scroll;" v-if="generatedAccount.length > 0">
            <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn flat icon type="button" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="generate_id" v-on="on">
              <v-icon style="color: #5f5f5f; font-size: 16px !important;">file_copy</v-icon></v-btn>
        </template>
        <span>Copy Generate ID</span>
      </v-tooltip>


          <!--  <p style="text-align: left; margin-bottom: 0; margin-top: 20px;"><b>Generate ID:</b> {{generate_id}}</p>

          <p style="text-align: left; margin-bottom: 0; margin-top: 20px;"><span style="color: red !important;">*</span> สามารถดูข้อมูลที่ทำการสร้างได้จากส่วนของ Report/ข้อมูล admin โดยค้นหาจาก Generate ID </p> -->

          <p style="text-align: left; margin-bottom: 0; margin-top: 20px;"><b>Generate ID:</b> {{generate_id}}</p>

          <p style="text-align: left; margin-bottom: 0; margin-top: 20px;"><span style="color: red !important;">*</span> สามารถดูข้อมูลที่ทำการสร้างได้จากส่วนของ Report/ข้อมูล admin โดยค้นหาจาก Generate ID หรือ <span @click="gotodetail" style="color: #a80d00; text-decoration: underline; font-weight: 800;cursor: pointer;">กดที่นี่</span> เพื่อแสดงข้อมูล</p>

        </v-card>
        <v-btn rounded color="primary" style="color: white; margin-bottom: 10px;" @click="successAccount()">สำเร็จ</v-btn>
      </v-stepper-content>
    </v-stepper-items>
    </v-stepper>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
import { Decode } from '@/services'
Vue.component(VueQrcode.name, VueQrcode)
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      radioTypeInfo: 0,
      StepCreate: 1,
      CompanyOwner: '',
      itemsCompany: [],
      role: 'maintenance',
      authen: {},
      headerAPI: {},
      NumAccount: 1,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      username: '',
      password: '',
      repassword: '',
      itemsCompanyOwnerBytype: [],
      generatedAccount: [],
      generate_id: '',
      phoneRules: [
        v => (!!v && v.length === 10) || 'กรุณาใส่เบอร์โทรศัพท์ของคุณจำนวน 10 หลัก',
        v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
        v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
      ],
      emailRules: [
        v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมลไม่ถูกต้อง'
      ],
      usernameRules: [
        v => ((!v && v.length < 6) || /^[^\W_]+$/.test(v)) || 'ไม่สามารถใช้อักขระพิเศษได้',
        v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว',
        v => /^([^A-Z])+$/.test(v) || 'กรุณาใส่ชื่อผู้ใช้งานเป็นภาษาอังกฤษ a-z และ 0-9 เท่านั้น',
        v => /^([a-z])+$/.test(v) || /^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(v) || 'กรุณาใส่ชื่อผู้ใช้งานที่ประกอบด้วยตัวอักษรภาษาอังกฤษ a-z อย่างน้อย1ตัว'
      ],
      passwordRules: [
        v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว'
      ],
      repasswordRules: [
        v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว',
        v => (v == this.password) || 'รหัสผ่านไม่ตรงกัน'
      ]
    }
  },
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.getCompanyMaintenance()
  },
  watch: {
    NumAccount () {
      if (this. NumAccount > 1000) {
        this.NumAccount = 1000
        this.$swal( 'ไม่สำเร็จ', 'ไม่ควรเกิน 1000', 'error' )
      }
    }
  },
  computed: {
  },
  methods: {
    gotodetail () {
      this.$router.push('/information_admin?id=' + this.generate_id)
    },
    checkNext () {
     if (this.first_name != '' && this.last_name != ''  && this.email != '' && this.phone != '' && this.username != '' && this.password != '' && this.repassword == this.password) {

      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email) && /^0[0-9]{9}$/.test(this.phone)) {
        return false
      } else {
        return true
      }
     } else {
      return true
     }
    },
    checkusername () {
      if ((this.username !='' && this.username.length < 6) || /^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(this.username)){
        return false
      } else {
        return true
      }
    },
    checkrepassword () {
      if ((this.repassword !='' && this.repassword.length < 6) || this.repassword !== this.password){
        return false
      } else {
        return true
      }
    },
    checkpassword () {
      if (this.password !='' && this.password.length < 6){
        return false
      } else {
        return true
      }
    },
    checkEmail () {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
    },
    checkPhone () {
      return /^0[0-9]{9}$/.test(this.phone)
    },
    successAccount () {
      this.StepCreate = 1
      this.radioTypeInfo = 0
      this.CompanyOwner = ''
      this.NumAccount = 1
      this.first_name = ''
      this.last_name = ''
      this.email = ''
      this.phone = ''
      this.username = ''
      this.password = ''
      this.repassword = ''
      this.role = ''
      this.generatedAccount = []
      this.generate_id = ''
    },
    CreateAccount () {
      this.$swal({
        title: 'ยืนยันการสร้าง Account?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          if (this.radioTypeInfo == 1) {
            var body = {
              first_name: this.first_name,
              last_name: this.last_name,
              email: this.email,
              phone: this.phone,
              username: this.username,
              password: this.password,
              company_id: this.CompanyOwner,
              role: this.role
            }
            this.axios.post(process.env.API_BACKEND + '/v1/createAdminByInfo', body, {headers: this.headerAPI}).then((response) => {
              if (response.data.message === 'success') {
                this.$swal( 'สำเร็จ', 'สร้างบัญชีสำเร็จแล้ว', 'success' )
                this.generatedAccount = [response.data.data]
                this.generate_id = response.data.data.generate_id
                this.StepCreate = 3
              } else if (response.data.message === 'username_is_already') {
                this.$swal( 'ไม่สำเร็จ', 'username ซ้ำกับในระบบ', 'error' )
              } else if (response.data.message === 'phone_is_already') {
                this.$swal( 'ไม่สำเร็จ', 'หมายเลขโทรศัพท์นี้ถูกลงทะเบียนในระบบแล้ว', 'error' )
              }
            })
          } else if (this.radioTypeInfo == 2) {
            var body = {
              number_account_create: this.NumAccount,
              company_id: this.CompanyOwner,
              role: this.role
            }
            this.axios.post(process.env.API_BACKEND + '/v1/createAdminBySystemGenerate', body, {headers: this.headerAPI}).then((response) => {
              if (response.data.message === 'success') {
                this.$swal( 'สำเร็จ', 'สร้างบัญชีสำเร็จแล้ว', 'success' )
                this.generatedAccount = response.data.data
                this.generate_id = response.data.data[0].generate_id
                this.StepCreate = 3
              }
            })
          }
        }
      })
    },
    getCompanyMaintenance () {
      this.axios.get(process.env.API_BACKEND + '/v1/getCompanyMaintenance', {headers: this.headerAPI}).then((response) => {
        this.itemsCompany = response.data.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.horizontal-center {
  margin-left: auto;
  margin-right: auto;
}
>>>.v-input--selection-controls .v-radio>.v-label {
  color: black;
  }
.pd-10 {
  padding: 10px !important;
}
.toolbarqrcode {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}
>>>.v-input .v-label {
    height: 30px;
    line-height: 30px;
}
.widthdivstep {
    width: 50vw;
    margin-top: 10px;
  }

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .widthdivstep {
    width: 86vw;
    margin-top: 10px;
  }
  
}

</style>



// WEBPACK FOOTER //
// src/components/create/create_accountMaintenance.vue